import "./src/styles/global.css";

// Track client-side route changes in GA once gtag has been lazily loaded
// (see the deferred loader in gatsby-ssr.js). Before gtag loads, route changes
// aren't sent — an accepted trade-off for keeping it off the critical path.
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search + location.hash,
    });
  }
};
